import { createContext, Dispatch, SetStateAction, useContext } from "react"

const defaultContent = {
  open: false,
  setOpen: (() => console.error("Context init missing")) as Dispatch<SetStateAction<boolean>>,
}

export const SheetContext = createContext(defaultContent)
export const useSheetContext = () => useContext(SheetContext)
